/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

// @mui material components
import Icon from '@mui/material/Icon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import TableHeader from 'components/Table/TableHeader';

// Material Dashboard 2 PRO React examples
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import { useSelector } from 'react-redux';
import * as Func from 'services/Function';

function AddER({ id, code, branch_id }) {
  const mod = 'export_invite';
  const app = useSelector((state) => state[APP_STATE]);
  const { t } = useTranslation();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [notify, setNotify] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalAdd, setModalAdd] = useState(false);
  const [filterPriority, setFilterPriority] = useState(null);

  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: 'vp.image_id', label: t(`attr.image`), align: 'center' },
    { id: 'vp.name', label: 'สินค้า', align: 'left' },
    { id: 'vp.quantity', label: 'ขอ', align: 'right' },
    { id: 'vp.quantity_balance', label: 'คงเหลือสต๊อก', align: 'right' },
    { id: 'vp.quantity_request', label: 'ค้างโอนใบหยิบ', align: 'right' },
    { id: 'vp.remain', label: 'เหลือ', align: 'right' },
    { id: 'vp.subunit_id', label: 'หน่วยนับ', align: 'left' },
  ];

  const view = (data) => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/check_add_er`, app.token, {
      id: id,
      page: data.page,
      per_page: data.perPage,
      orderby: data.orderBy,
      ordersort: data.order,
    }).then((result) => {
      if (result.status === 'ok') {
        setModalAdd(true);
        setRecord(result.list);

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      } else {
        setNotify(t(`alert.saveerror`), 'error');
      }
      setLoading(false);
    });
  };

  const save = () => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/add_er`, app.token, {
      // id: id,
      code: code,
      branch_id: branch_id,
      date_record: Func.dateNow(),
      list: record,
    }).then((result) => {
      if (result.status === 'ok') {
        window.location.replace(`/export_request/${result.id}`);
      } else {
        setNotify(t(`alert.saveerror`), 'error');
      }
      setLoading(false);
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  // const renderShow = (
  //   <Menu
  //     anchorEl={show}
  //     anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
  //     transformOrigin={{ vertical: 'top', horizontal: 'left' }}
  //     open={Boolean(show)}
  //     onClose={closeShow}
  //     keepMounted
  //   >
  //     <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
  //       {t(`element.show_record`, { num: 10 })}
  //     </MenuItem>
  //     <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
  //       {t(`element.show_record`, { num: 20 })}
  //     </MenuItem>
  //     <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
  //       {t(`element.show_record`, { num: 100 })}
  //     </MenuItem>
  //   </Menu>
  // );

  const imageDisplay = (item) => {
    return <Avatar alt={item.name} src={item.image} variant='rounded' />;
  };
  const renderList = () => {
    return (
      <MDBox>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TableContainer sx={{ boxShadow: 0, minHeight: 500 }}>
              <Table aria-label='simple table'>
                <TableHeader data={initHeader} />
                <TableBody>
                  {(filterPriority
                    ? record.filter((r) => r.color_priority === filterPriority)
                    : record
                  ).map((row) => (
                    <TableRow key={row.id} hover className={`highlight-${row.color}`}>
                      <TableCell width='40'>{imageDisplay(row)}</TableCell>
                      <TableCell>
                        <MDBox>{row.sku}</MDBox>
                        <MDBox>{row.name}</MDBox>
                      </TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.quantity)}</TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.quantity_balance)}
                      </TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.quantity_request)}
                      </TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.remain)}</TableCell>
                      <TableCell align='left'>{row.unit_name}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          {/* <Grid item xs={12}>
            <MDBox display='flex' justifyContent='space-between' alignItems='flex-start'>
              <MDButton variant={show ? 'contained' : 'outlined'} color='dark' onClick={openShow}>
                {t(`element.show_record`, { num: find.perPage })}&nbsp;
                <Icon>keyboard_arrow_down</Icon>
              </MDButton>
              {renderShow}
              <Pagination
                count={pageTotal}
                variant='outlined'
                color='secondary'
                showFirstButton
                showLastButton
                page={pageNo}
                onChange={(e, p) => view({ ...find, page: p })}
              />
            </MDBox>
          </Grid> */}
        </Grid>
      </MDBox>
    );
  };

  const renderAdd = () => {
    return (
      <Dialog
        open={modalAdd}
        maxWidth='xxl'
        keepMounted
        aria-describedby='dialog-add'
        fullWidth
        onClose={() => setModalAdd(false)}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            pr: 1,
            py: 1.5,
          }}
        >
          สินค้า
          <MDBox
            display='flex'
            justifyContent='center'
            alignItems='center'
            gap={1}
            flex={1}
            flexWrap='wrap'
          >
            {[
              { color: '#ffebee', border: '#ef9a9a', label: 'สต๊อกหมด', priority: '1' },
              { color: '#fffde7', border: '#fff176', label: 'สต๊อกมีไม่พอ', priority: '2' },
              { color: '#e8f5e9', border: '#a5d6a7', label: 'สต๊อกเพียงพอ', priority: '3' },
            ].map(({ color, border, label, priority }) => (
              <MDBox
                key={label}
                display='flex'
                alignItems='center'
                gap={0.5}
                onClick={() => setFilterPriority((prev) => (prev === priority ? null : priority))}
                sx={{
                  px: 1,
                  py: 0.25,
                  borderRadius: '6px',
                  backgroundColor: color,
                  border:
                    filterPriority === priority ? `2px solid ${border}` : `1px solid ${border}`,
                  outline: filterPriority === priority ? `2px solid ${border}` : 'none',
                  fontSize: '0.72rem',
                  fontWeight: filterPriority === priority ? 700 : 500,
                  color: '#444',
                  lineHeight: 1.5,
                  cursor: 'pointer',
                  userSelect: 'none',
                  opacity: filterPriority !== null && filterPriority !== priority ? 0.45 : 1,
                  transition: 'all 0.15s ease',
                  '&:hover': { opacity: 1, filter: 'brightness(0.95)' },
                }}
              >
                <MDBox
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor: border,
                    flexShrink: 0,
                  }}
                />
                {label}
              </MDBox>
            ))}
          </MDBox>
          <IconButton
            aria-label='close'
            onClick={() => setModalAdd(false)}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>{renderList()}</DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between' }}>
          <MDButton
            variant='text'
            color='error'
            size='small'
            onClick={() => setModalAdd(false)}
            disabled={loading}
          >
            <Icon>cancel</Icon>&nbsp;{t('element.cancel')}
          </MDButton>
          <MDButton variant='text' color='success' size='small' onClick={save} disabled={loading}>
            <Icon>check</Icon>&nbsp;{t('element.saveconfirm')}
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <>
      <MDButton variant='gradient' color='info' onClick={view}>
        <Icon>description</Icon>&nbsp;สร้างใบหยิบสินค้า
      </MDButton>
      {renderAdd()}
      {renderLoading()}
      {notify}
    </>
  );
}

AddER.propTypes = {
  id: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  branch_id: PropTypes.string.isRequired,
};

export default AddER;
